import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

export default function ReminderNotes({
  textReminder,
  handleTextChangeHandler,
}) {
  return (
    <Box>
      <Typography
        variant='h6'
        gutterBottom
        sx={{ 
          fontWeight: 900,
          color: '#333',
          mb: 2,
          fontSize: '1.1rem'
        }}
      >
        Reminder Notes
      </Typography>
      <TextField
        value={textReminder}
        onChange={handleTextChangeHandler}
        fullWidth
        multiline
        rows={3}
        sx={{ backgroundColor: '#fff' }}
      />
    </Box>
  );
} 